var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 450",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M115.45,187.93C125.14,186.29,125,168,125,168l1.61-9.89a6.9,6.9,0,0,0-4.74-7.89l-8.05-2.64-.25-.08a6.88,6.88,0,0,0-8.59,4.59l-2.33,7.47a22.35,22.35,0,0,0-.83,9.37L103.79,184Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.46,280.52l.11.15a40.49,40.49,0,0,1-11.82,3,70.9,70.9,0,0,1-11.75.15c-7.77-.4-15.59-1.08-23.36-2.1q-9.4-1.2-18.69-3.21s-.26-.05-.71-.17c-1.5-.4-24.46-2-32.23-7.22C105.22,262.5,103.79,184,103.79,184l14.77,2.14,20.73,55.27,18.28-1.53a121.24,121.24,0,0,1,26.16,1.29c10.72,1.92,19.1,1.41,17.64,1,7.29-.43,19.39-2.51,26.25.13C227.62,242.37,242.23,271.37,216.46,280.52Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.8,268.13c-4.8,55.09-23.09,86.13-20.63,130.18,0,0-100.26-1.7-103.66-1.7-1.45-81.16-14.4-71.09-10.86-122.44-.61-16.93,11.85-28.63,21.55-30.31l41.77-7.6,54.51,9.36A21,21,0,0,1,318.8,268.13Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.69,209.8c2.39,11.32,6.23,27.21-10.08,29.85-4.77,5.95-6.75,17.59,8.59,25.26,19.61-4.66,43.51-13.22,45.81-22.68-16.37-2.82-10.33-37-9.3-51.21Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.69,207A34.38,34.38,0,0,1,259,217.49c-4,4.64-11.69,6.69-19.06,6.69a74.6,74.6,0,0,0-2.18-14.49l1.54-.81Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.78,195.66c2.73,20,26,31.51,42.28,18,9.41-7.76,11.29-17.45,13.64-32.59.36-2.29.73-4.71,1.15-7.28a27.45,27.45,0,0,0-.67-12,24.59,24.59,0,0,0-1.84-4.69,27,27,0,0,0-31.6-13.89C223.81,149,218.3,177.68,220.78,195.66Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.09,200.27a13.82,13.82,0,0,0,10-4.11.47.47,0,0,0-.05-.67.46.46,0,0,0-.66,0,13.23,13.23,0,0,1-11,3.69.46.46,0,0,0-.52.41.46.46,0,0,0,.41.52A14.94,14.94,0,0,0,236.09,200.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.12,172.67c2.11.07,4.47.6,5.43,2.16.68,1.1,2,9.53,1,12l1.21.2a20.3,20.3,0,0,1,8.18-6c.43-2.29,2.72-22.67,1.81-24.14-3.32-2.86-13.8-3.86-20.14-2.24C262.62,154.72,263,172.63,265.12,172.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,180.64c-6.25-1.45-12,5.42-14.06,10.61-2.29,5.76.46,11.68,6.89,10.51a18.39,18.39,0,0,0,11.88-7.83C288.54,188.88,286.74,182.08,280.5,180.64Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.23,175.28c-1-.11-2,1.11-2.16,2.69s.42,3,1.59,3.08,2.13-1.08,2.29-2.69S242.27,175.4,241.23,175.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.3,174c-1-.12-2,1.07-2.15,2.66s.52,3,1.58,3.08,2-1.08,2.18-2.67S224.34,174.13,223.3,174Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.67,193.48a9.18,9.18,0,0,1-7.48-2.25,56,56,0,0,0,8.86-12.82Z",
    style: {
      fill: "#c06d49"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.76,170.75a7.56,7.56,0,0,0-5.69-3.77h0a.76.76,0,0,1-.3,0,.94.94,0,0,1,.3-1.86,9.36,9.36,0,0,1,7.21,4.59A1,1,0,0,1,252,171a.86.86,0,0,1-.46.14A1,1,0,0,1,250.76,170.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.1,167.92h0a.94.94,0,0,1-.15-1.33,9.18,9.18,0,0,1,7.69-3.67h0a.93.93,0,0,1,.82,1s0,.05,0,.08a.89.89,0,0,1-1,.77,7.39,7.39,0,0,0-6.06,3,.93.93,0,0,1-.81.37A1,1,0,0,1,222.1,167.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.72,157c2.09-6.62-1.39-16-5.67-21.47-.5,3.76-1.74,9.4-1.74,9.4-4.91-7.12-6.87-13.52-4.74-17-4.93,2.5-7.85,8.64-6.42,13.89a11.42,11.42,0,0,1-7.87-7.82c-1-3.71.69-10,3.44-12.7-7,2.19-11.9,9.43-12.28,16.61a8.56,8.56,0,0,1-4.94-6.82c-.28-2.9.85-6.73,3.27-8.42A16.48,16.48,0,0,0,235.08,142a9.12,9.12,0,0,1-7.8-7.08,15.93,15.93,0,0,0,4.53,17.43c1.75,1.49,4,1.17,6.14,2.12C246.76,153,279.33,155.22,282.72,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.74,406.67c2.94-42.83,9.86-73.78,17.66-112.65-1.57,1.05-1.3,20.9-12.81,37.16-6,8.49-19.24,3.84-22.54-4.54-11.07-28.19-4.49-47.72,16.13-82.46-4.52-.85,0,0-3.83-1.85a1.47,1.47,0,0,0-2,.69c-8.45,17.36-35.23,54.29-71.15,51.39-14-1.14-7.16-26-4.8-31.59,3.8-9,9.09-15.76,14.56-23.89-3.13,1.19-2.7-.77-5.19,1.48-21.43,19.49-35.85,45-40.09,73.68,0,0,2.66,67.27,6.21,93.09Z",
    style: {
      fill: "#1B4ED8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.4,294c-3.86,18.49-5.69,28.92-9,43.8a61.92,61.92,0,0,1-11.87-34.22c-.67-12.05,6.36-23.37,10.49-25.14Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,401.37l-2-.08c1.6-40.61,7.21-67,7.26-67.22l2,.42C298.8,334.75,293.23,361,291.64,401.37Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.35,401.37l-2-.08c1.6-40.59,6-64.7,6-64.94l2,.36C287.28,337,282.94,360.93,281.35,401.37Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.19,264.75c3.28,9.89,1.48,20.76-4.06,29.58-12.2,19.43-40.13,61.23-49.94,64.33-12.58,4-63.47-49.21-63.47-49.21l7.52-13.19,47.52,23.9s17.3-70.43,34-73.08C309.66,245.19,321.6,250.89,326.19,264.75Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.32,268.76a7.45,7.45,0,1,1-7.24-7.66A7.45,7.45,0,0,1,166.32,268.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,273.51l-4.76-.14h0a13.16,13.16,0,0,1,.19-9.15l.08-.2,4.76.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.56,273.51l-4.76-.14h0a13.16,13.16,0,0,1,.19-9.15l.08-.2,4.76.13Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,276.94l-44.45-1.26h0a50.47,50.47,0,0,1,.33-12.76l0-.2L213.23,264Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.86,276.94l-44.45-1.26h0a50.47,50.47,0,0,1,.33-12.76l0-.2L213.23,264Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,285.62l-17-.48v-.35a6.37,6.37,0,0,0-6.14-6.6h0l6.94-21.62,17,.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.67,285.62l-17-.48v-.35a6.37,6.37,0,0,0-6.14-6.6h0l6.94-21.62,17,.48Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,285.37h13.51a0,0,0,0,1,0,0v30.39a3.13,3.13,0,0,1-3.13,3.13h-7.25a3.13,3.13,0,0,1-3.13-3.13V285.37a0,0,0,0,1,0,0Z",
    transform: "translate(8.64 -5.61) rotate(1.62)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.71,285.37h13.51a0,0,0,0,1,0,0v30.39a3.13,3.13,0,0,1-3.13,3.13h-7.25a3.13,3.13,0,0,1-3.13-3.13V285.37a0,0,0,0,1,0,0Z",
    transform: "translate(8.64 -5.61) rotate(1.62)",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 261.52,
    width: 44.47,
    height: 16.85,
    transform: "translate(7.73 -5.41) rotate(1.62)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.63,
    y: 261.52,
    width: 44.47,
    height: 16.85,
    transform: "translate(7.73 -5.41) rotate(1.62)",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.82,270.44h0a.5.5,0,0,1-.48-.51l.18-6.43A.52.52,0,0,1,177,263a.5.5,0,0,1,.49.52l-.18,6.43A.5.5,0,0,1,176.82,270.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.73,270.44h0a.51.51,0,0,1-.49-.51l.19-6.43a.5.5,0,1,1,1,0l-.19,6.43A.49.49,0,0,1,179.73,270.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.65,270.44h0a.5.5,0,0,1-.49-.51l.18-6.43a.54.54,0,0,1,.52-.49.5.5,0,0,1,.48.52l-.18,6.43A.5.5,0,0,1,182.65,270.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.57,270.44h0a.5.5,0,0,1-.48-.51l.18-6.43a.53.53,0,0,1,.51-.49.5.5,0,0,1,.49.52l-.18,6.43A.5.5,0,0,1,185.57,270.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.47,273.18l-9.37-.26a2.46,2.46,0,0,1-2.39-2.53h0a2.46,2.46,0,0,1,2.53-2.39l9.37.27A2.47,2.47,0,0,1,210,270.8h0A2.46,2.46,0,0,1,207.47,273.18Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.81,309.49c-6,6.64-19.93-2.37-19.93-2.37l-8.4-3.69a6.24,6.24,0,0,1-3.62-7.32l1.79-7.49.06-.23a6.27,6.27,0,0,1,7.71-4.35l6.85,1.87a19.86,19.86,0,0,1,7.58,4l10.62,8.85Z",
    style: {
      fill: "#f1a06a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.08,257.65a.48.48,0,0,1-.2,0,.51.51,0,0,1-.27-.65,7.05,7.05,0,0,1,7.22-4.16.5.5,0,0,1,.43.56.49.49,0,0,1-.56.43,6,6,0,0,0-6.16,3.55A.51.51,0,0,1,151.08,257.65Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.73,259.06h-.08a.5.5,0,0,1-.41-.57,2.86,2.86,0,0,1,3.7-2.13.51.51,0,0,1,.29.65.5.5,0,0,1-.65.29,1.76,1.76,0,0,0-1.47.16,1.73,1.73,0,0,0-.88,1.19A.5.5,0,0,1,153.73,259.06Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.86,281.62l-.14,0a11.89,11.89,0,0,1-7.77-7.18.5.5,0,1,1,.94-.35,10.84,10.84,0,0,0,7.1,6.57.5.5,0,0,1-.13,1Z",
    style: {
      fill: "#7be7c6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6,277.82h-.09a3.8,3.8,0,0,1-3-3.31.5.5,0,0,1,1-.09,2.81,2.81,0,0,0,2.18,2.42.5.5,0,0,1,.39.59A.49.49,0,0,1,153.6,277.82Z",
    style: {
      fill: "#7be7c6"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.d874c49b2a537e36e88268fb28cc6ba4.svg";
export { ForwardRef as ReactComponent };